// 客户管理页
<template>
  <div style="height: 100%;">
    <Header></Header>
    <div class="clientMain">
      <vxe-button icon="vxe-icon--plus" @click="insertEvent" size="medium">新增</vxe-button>
      <vxe-table highlight-hover-row :data="tableData" row-class-name="clientManagerRow" header-row-class-name="clientManagerHeader" class="mt-10 mytable-scrollbar" size="medium" round stripe ref="xTable" :align="'center'" height="auto" :loading="loading" :sort-config="{ 'defaultSort': { field: 'age', order: 'desc' } }">
        <vxe-table-column field="name" title="名字" sortable :filters="[{ data: '' }]" :filter-recover-method="filterNameRecoverMethod" :filter-method="filterNameMethod">
          <template v-slot:filter="{ $panel, column }">
            <input v-for="(option, index) in column.filters" class="my-input" type="type" placeholder="按回车确认筛选" :key="index" v-model="option.data" @input="$panel.changeOption($event, !!option.data, option)" @keyup.enter="$panel.confirmFilter()">
          </template>
        </vxe-table-column>
        <vxe-table-column field="gender" title="性别" sortable :filter-multiple="false" :filters="[{ label: '男', value: '男' }, { label: '女', value: '女' }]">
        </vxe-table-column>
        <vxe-table-column :filters="[{ data: '' }]" :filter-method="filterAgeMethod" :filter-recover-method="filterAgeRecoverMethod" field="age" title="年龄">
          <template v-slot:filter="{ $panel, column }">
            <input type="type" v-model="startAge" placeholder="请输入起始年龄范围"> -
            <input v-for="(option, index) in column.filters" class="my-input" type="type" placeholder="按回车确认筛选" :key="index" v-model="option.data" @input="$panel.changeOption($event, !!option.data, option)" @keyup.enter="$panel.confirmFilter()">
          </template>
        </vxe-table-column>
        <vxe-table-column :filters="cityFilterList" :key="cityFilterListKey" field="city" title="城市" sortable :filter-method="filterCityMethod"></vxe-table-column>
        <vxe-table-column field="created_date" title="跟进时间" sortable></vxe-table-column>
        <vxe-table-column field="updated_date" title="信息更新日期" sortable></vxe-table-column>
        <vxe-table-column title="操作" width="150" show-overflow>
          <template v-slot="{ row }">
            <vxe-button type="text" :title="'编辑'" icon="iconfont icon-V" @click="editEvent(row)"></vxe-button>
            <vxe-button type="text" :title="'删除'" icon="iconfont icon-shanchu" style="margin-left: 0;" @click="removeEvent(row)"></vxe-button>
            <vxe-button type="text" :title="'跳转'" icon="iconfont icon-tiaozhuan" style="margin-left: 0;" @click="toRedPlaning(row)"></vxe-button>
          </template>
        </vxe-table-column>
        <template v-slot:empty>
          <span style="color: red;">
            <img style="width: 300px;" src="../../static/nothing-data.gif">
            <p>暂无数据！</p>
          </span>
        </template>
      </vxe-table>
      <!-- 新增客户（卡片）& 编辑客户信息 -->
      <vxe-modal v-model="showAddEdit" className="clientManagerModel" width="800" min-width="600" min-height="300" resize destroy-on-close size="medium" :show-zoom="false" :loading="submitLoading" :title="selectRow ? '编辑&保存' : '新增&保存'">
        <template v-slot>
          <span v-if="isEdit" class="absolute cursor color-primary f14 zIndex999" style="right: 40px;top: 28px;" @click="showRiskAppetite">风险偏好</span>
          <span v-if="isEdit" class="iconfont icon-guketiaochawenjuanbiao absolute f18 cursor color-primary zIndex999" title="调查问卷" style="right: 100px;top:25px;" @click="showQuestionnaire = true"></span>
          <vxe-form :data="formData" :items="formItems" :rules="formRules" title-align="right" title-width="100" @submit="submitEvent" :prevent-submit="false"></vxe-form>
        </template>
      </vxe-modal>
      <!-- 风险偏好 -->
      <vxe-modal v-model="showQuestionnaire" className="clientManagerQuestionnaire f16" :title="'为了我们更好的了解您，请您填写风险偏好'" :loading="submitLoading" destroy-on-close size="medium" :class="{ 'apply-shake': isShakeTextName }" :show-zoom="false" width="700" @close="closeQuestionnaire">
        <template v-slot>
          <div style="border-bottom: 1px solid gray;line-height: 16px;" class="pb20">
            <span class="fb f16">测评进度</span>
            <el-progress :key="percentageValueKey" :percentage="percentageValue" style="width: 88%; float: right;"></el-progress>
            <!-- <ProgressBar :progress="progress"></ProgressBar> -->
          </div>
          <div class="f14 pb20 pt20" style="border-bottom: 1px dotted gray;">
            <p class="fb mb-10">Q1: &nbsp;&nbsp;您认为您对于投资的偏好是什么？</p>
            <vxe-radio-group v-model="q1_value" class="mt-5">
              <vxe-radio name="保守" label="保守" content="保守"></vxe-radio>
              <vxe-radio name="中性" label="中性" content="中性"></vxe-radio>
              <vxe-radio name="激进" label="激进" content="激进"></vxe-radio>
            </vxe-radio-group>
          </div>
          <div class="f14 pb20 pt20" style="border-bottom: 1px dotted gray;">
            <p class="fb mb-10">Q2: &nbsp;&nbsp;您的投资经验有多少年？</p>
            <vxe-radio-group v-model="q2_value" class="mt-5">
              <vxe-radio name="1-3年" label="1-3年" content="1-3年"></vxe-radio>
              <vxe-radio name="5-10年" label="5-10年" content="5-10年"></vxe-radio>
              <vxe-radio name="10年以上" label="10年以上" content="10年以上"></vxe-radio>
            </vxe-radio-group>
          </div>
          <div class="pt20 f14 pb20" style="border-bottom: 1px dotted gray;">
            <p class="fb mb-10">Q3: &nbsp;&nbsp;如果现有两个投资产品，一个投资产品有100%的机会可以获得3%的收益，另外一个产品有50%的机会获得15%的收益，50%的机会获得-5%的收益，您会选择哪一个？</p>
            <vxe-radio-group v-model="q3_value" class="mt-5">
              <vxe-radio name="第一个投资产品" label="第一个投资产品" content="第一个投资产品"></vxe-radio>
              <vxe-radio name="第二个投资产品" label="第二个投资产品" content="第二个投资产品"></vxe-radio>
            </vxe-radio-group>
          </div>
          <div class="pt20 f14 pb20" style="border-bottom: 1px dotted gray;">
            <p class="fb mb-10">Q4: &nbsp;&nbsp;您需要的退休生活水平是怎么样的？</p>
            <vxe-radio-group v-model="q4_value" class="mt-5">
              <vxe-radio name="基础" label="基础" content="基础"></vxe-radio>
              <vxe-radio name="舒适" label="舒适" content="舒适"></vxe-radio>
              <vxe-radio name="富足" label="富足" content="富足"></vxe-radio>
              <vxe-radio name="奢侈" label="奢侈" content="奢侈"></vxe-radio>
            </vxe-radio-group>
          </div>
          <div class="ac">
            <vxe-button type="submit" status="primary" class="mt-20" @click="confirmQuestionnaire">确定</vxe-button>
          </div>
        </template>
      </vxe-modal>
      <!-- 删除客户（卡片） -->
      <vxe-modal v-model="delEdit" className="clientManagerModel" title="消息提示" width="420" min-width="420" min-height="160" destroy-on-close size="medium" :show-zoom="false" :showFooter="true" @confirm="confirmDel()">
        <template v-slot>
          <i class="iconfont icon-tishi1" style="color: orange;"></i><span class="f13 fb ml-10">您确定删除该数据？</span>
        </template>
      </vxe-modal>
    </div>
  </div>
</template>

<script>
// import Mock from 'mockjs'
import Header from './Header.vue'
import ProgressBar from '@/components/ProgressBar'
export default {
  components: { Header, ProgressBar },
  data () {
    return {
      cityFilterList: [],
      progress: 0,
      percentageValueKey: String(new Date()),
      isEdit: false, // 是否是编辑界面
      isShakeTextName: false,
      startAge: '',
      percentageValue: 0,
      q1_value: '',
      q2_value: '',
      q3_value: '',
      q4_value: '',
      showQuestionnaire: false,
      delEdit: false,
      submitLoading: false,
      showAddEdit: false,
      loading: false,
      tableData: [],
      cityList: [],
      selectRow: null,
      questionFormData: {},
      formData: {
        name: null,
        gender: null,
        age: null,
        city: null,
        followUpDate: null, // 跟进日期
        currentDate: new Date(),
        mainDemand: null,
        existingProduct: null,
      },
      formRules: {
        name: [
          { required: true, message: '请输入名称' },
        ],
        age: [
          { required: true, message: '请输入年龄' }
        ],
        gender: [
          { required: true, message: '请选择性别' }
        ]
      },
      formItems: [
        { title: '基本信息', span: 24, titleAlign: 'left', titleWidth: 200 },
        { field: 'name', title: '姓名', span: 12, itemRender: { name: '$input', props: { placeholder: '请输入名称', prefixIcon: 'iconfont icon-xingming' } } },
        { field: 'gender', title: '性别', span: 12, itemRender: { name: '$select', options: [{ label: '男', value: '男' }, { label: '女', value: '女' }], props: { prefixIcon: 'iconfont icon-nianling', placeholder: '请选择性别' } } },
        { field: 'age', title: '年龄', span: 12, itemRender: { name: '$input', props: { type: 'number', placeholder: '请输入年龄', prefixIcon: 'iconfont icon-nianling', max: 105 } } },
        { field: 'city', title: '城市', span: 12, itemRender: { name: '$select', options: [], props: { prefixIcon: 'iconfont icon-chengshi' } } },
        { title: '咨询进度', span: 24, titleAlign: 'left', titleWidth: 200 },
        { field: 'followUpDate', title: '跟进日期', span: 12, itemRender: { name: '$input', props: { type: 'date', placeholder: '请选择日期' } } },
        { field: 'currentDate', title: '信息更新日期', span: 12, itemRender: { name: '$input', props: { type: 'date', disabled: true } } },
        { field: 'mainDemand', title: '主要需求', span: 12, itemRender: { name: '$textarea', props: { autosize: { minRows: 2, maxRows: 4 }, placeholder: '请输入主要需求' } } },
        { field: 'existingProduct', title: '已有产品', span: 12, itemRender: { name: '$textarea', props: { autosize: { minRows: 2, maxRows: 4 }, placeholder: '请输入已有产品' } } },
        { align: 'center', span: 24, titleAlign: 'left', itemRender: { name: '$buttons', children: [{ props: { type: 'submit', content: '保存', status: 'primary' } }, { props: { type: 'reset', content: '重置' } }] } }
      ],
      currentDelRow: {},
      currentClientRiskAppetiteId: 0,
      currentClientEditId: 0,
      cityFilterListKey: 'ccccc'
    }
  },
  watch: {
    q1_value (newVal, oldVal) {
      if (this.percentageValue < 100) {
        if (oldVal === '') {
          this.percentageValue += 25
        }
      }
    },
    q2_value (newVal, oldVal) {
      if (this.percentageValue < 100) {
        if (oldVal === '') {
          this.percentageValue += 25
        }
      }
    },
    q3_value (newVal, oldVal) {
      if (this.percentageValue < 100) {
        if (oldVal === '') {
          this.percentageValue += 25
        }
      }
    },
    q4_value (newVal, oldVal) {
      if (this.percentageValue < 100) {
        if (oldVal === '') {
          this.percentageValue += 25
        }
      }
    }
  },
  computed: {
    progressStyle () {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        backgroundColor: this.bgColor
      }
    },
    fillStyle () {
      return {
        width: `${this.progress}%`,
        height: `${this.height}px`,
        backgroundColor: this.fillColor
      }
    },
    token () {
      return this.$store.getters.getToken
    }
  },
  mounted () {
    // 禁止回退
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    })
    this.token === '' ? localStorage.getItem('token') : this.token
    this.getCityList()
    this.findList()
  },
  methods: {
    getCityList () {
      this.$http.post(this.$api.SupportCities, {}, {Authorization: `Bearer ${localStorage.getItem('token')}`}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          this.formItems.filter(item => {
            if (item.field === 'city') {
              item.itemRender.options = res.data.map(value => ({ label: value.name, value: value.name }))
            }
          })
         }
      })
    },
    // 关闭问卷调查
    closeQuestionnaire () {
      // console.log(this.isEdit);
      if (!this.isEdit) {
        this.percentageValue = 0
        this.percentageValueKey = String(new Date())
      }
    },
    // 获取某客户（卡片）风险偏好
    showRiskAppetite () {
      this.showQuestionnaire = true
      const url = `/api/client/get_risk_appetite/${Number(this.currentClientRiskAppetiteId)}`
      // const params = { 'risk_appetite_id': Number(this.currentClientRiskAppetiteId) }
      this.$http.get(url, {}, { Authorization: `Bearer ${localStorage.getItem('token')}` }, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          // console.log(res);
          this.$nextTick(() => {
            this.percentageValue = 100
            this.q1_value = res.data.risk_appetite_detail.q1
            this.q2_value = res.data.risk_appetite_detail.q2
            this.q3_value = res.data.risk_appetite_detail.q3
            this.q4_value = res.data.risk_appetite_detail.q4
          })
        }
      })
    },
    toRedPlaning (row) {
      // console.log(row.$event)

      const url = `/api/client/get_risk_appetite/${Number(row.risk_appetite_id)}`
      this.$http.get(url, {}, { Authorization: `Bearer ${localStorage.getItem('token')}` }, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          const info = {
            'age': row.age,
            'city': row.city,
            'gender': row.gender === '男' ? 'male' : 'female',
            'ANSWER1': res.data.risk_appetite_detail.q1,
            'ANSWER2': res.data.risk_appetite_detail.q2,
            'ANSWER3': res.data.risk_appetite_detail.q3,
            'ANSWER4': res.data.risk_appetite_detail.q4
          }
          this.$router.push({ name: 'ResultNew', params: info })
        }
      })
    },
    // 新增按钮
    insertEvent () {
      this.percentageValue = 0
      this.q1_value = ''
      this.q2_value = ''
      this.q3_value = ''
      this.q4_value = ''
      this.showQuestionnaire = true
      this.isEdit = false
      this.percentageValueKey = String(new Date())
    },
    // 风险偏好确认提交
    confirmQuestionnaire () {
      if (this.percentageValue === 100) {
        this.showQuestionnaire = false
        // console.log(this.isEdit);
        if (!this.isEdit) {
          this.showAddEdit = true
          this.formData = {
            name: '',
            gender: '',
            age: '',
            city: '',
            followUpDate: '',
            currentDate: new Date(),
            mainDemand: '',
            existingProduct: '',
            questionnaire: {
              q1_value: this.q1_value,
              q2_value: this.q2_value,
              q3_value: this.q3_value,
              q4_value: this.q4_value
            }
          }
          this.selectRow = null  // 非编辑状态下，填完风险评估显示空的信息表用户增加新客户（卡片）
        } else {
          // 保存修改好的风险偏好信息
          const url = `/api/client/update_risk_appetite/${this.currentClientRiskAppetiteId}`
          const params = { 'q1': this.q1_value, 'q2': this.q2_value, 'q3': this.q3_value, 'q4': this.q4_value }
          this.$http.put(url, params, {Authorization: `Bearer ${localStorage.getItem('token')}`}, window._env_.api_url, res => {
            if (res.status >= 200 && res.status < 300) {
              this.$message({type: 'success', message: '风险偏好已更新！'})
             }
          })
        }
      } else {
        // 如果风险偏好不为百分百，窗口抖动
        setTimeout(() => {
          this.isShakeTextName = false
        }, 820)
        this.isShakeTextName = true
      }
    },
    // 编辑客户（卡片）信息
    editEvent (row) {
      this.formData = {
          name: row.name,
          gender: row.gender,
          age: row.age,
          followUpDate: '',
          city: row.city,
          existingProduct: row.exist_product,
          currentDate: row.updated_date,
          mainDemand: ''
        }
      // console.log(row);
      // 获取对应卡片最新填写的主要需求
      const url = `/api/client/card_requirements/`
      const params = {card_id: row.id}
      this.$http.get(url, params, {Authorization: `Bearer ${localStorage.getItem('token')}`}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          // console.log(res);
          this.$nextTick(() => {
            if (res.data.requirements !== null) {
              this.formData = Object.assign({}, this.formData, {'mainDemand': res.data.requirements.description, 'followUpDate': res.data.requirements.follow_up_date})
              // this.formData.mainDemand = res.data.requirements.description
              // this.formData.followUpDate = res.data.requirements.follow_up_date
            }
          })
        }
      })
      this.showAddEdit = true
      this.isEdit = true
      this.selectRow = row
      this.currentClientRiskAppetiteId = row.risk_appetite_id
      this.currentClientEditId = row.id
    },
    // 确定移除项
    removeEvent (row) {
      this.delEdit = true
      this.currentDelRow = row
    },
    confirmDel () {
      const url =  `/api/client/delete_card/${Number(this.currentDelRow.id)}`
      this.$http.delete(url, {}, {Authorization: `Bearer ${localStorage.getItem('token')}`}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          // console.log(res);
          this.findList()
          this.$message({type: 'success', message: '已删除！'})
        }
      })
    },
    // 确认新增用户（卡片）信息 以及 更新卡片信息
    submitEvent (data) {
      // return
      if (this.isEdit) {
        this.submitLoading = true
        const editUrl = `/api/client/update_card/${this.currentClientEditId}`
        const editParams = {
          "name": data.data.name,
          "age": Number(data.data.age),
          "gender": data.data.gender,
          "city": data.data.city,
          "requirement": data.data.mainDemand,
          "exist_product": data.data.existingProduct,
          "created_date": new Date(data.data.followUpDate),
          "updated_date": new Date()
        }
        // console.log(editParams);
        // return
        this.$http.put(editUrl, editParams, {Authorization: `Bearer ${localStorage.getItem('token')}`}, window._env_.api_url, res => {
          if (res.status >= 200 && res.status < 300) {
            // console.log(res);
            this.findList()
            this.submitLoading = false
            this.isEdit = false
            this.showAddEdit = false // 关闭编辑态下的模态框
            this.$message({type: 'success', message: '基本信息已更新！'})
           }
        })
      } else {
        const url = '/api/client/add_new_card/'
        const params = {
          "card_info": {
            "name": data.data.name,
            "age": Number(data.data.age),
            "gender": data.data.gender,
            "city": data.data.city,
            "requirement": data.data.mainDemand,
            "exist_product": data.data.existingProduct,
            // "created_date": data.data.followUpDate === '' ? new Date() : new Date(data.data.followUpDate),
            "created_date": data.data.followUpDate === '' && data.data.mainDemand !== '' ? new Date() :  new Date(data.data.followUpDate),
            "updated_date": new Date()
          },
          "risk_appetite_detail": { 'q1': this.q1_value, 'q2': this.q2_value, 'q3': this.q3_value, 'q4': this.q4_value },
          "email": localStorage.getItem('username')
        }
        const header = { 'token': `Bearer ${localStorage.getItem('token')}` }
        this.$http.post(url, params, header, window._env_.api_url, res => {
          if (res.status >= 200 && res.status < 300) {
            // console.log(res);
            this.findList()
            this.submitLoading = false
            this.isEdit = false
            this.showAddEdit = false // 关闭新增状态下的模态框
            // this.$message({type: 'success', message: res.data.message})
          }
        })
      }
    },
    // 初始化默认数据
    findList () {
      this.loading = true
      const url = '/api/client/card_list/'
      const header = { 'token': `Bearer ${localStorage.getItem('token')}` }
      const params = { "email": localStorage.getItem('username') }
      this.$http.post(url, params, header, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          const totalCity = res.data.card_list.map(item => item.city)
          const uniqueCity = [...new Set(totalCity)]
          this.cityFilterList = uniqueCity.map(value => ({ label: value, value }))
          this.cityFilterListKey = 'xxxxx' // 强制刷新city的key值便于更新DOM元素

          this.tableData = res.data.card_list
          this.loading = false
          this.tableData.map(item => {
            item.true_updated_date = new Date(item.updated_date) // 日期字符串转换真实日期
          })
          // 根据跟进日期排序
          this.tableData.sort((a, b) => {
            const dateA = a.true_updated_date
            const dateB = b.true_updated_date
            if (dateA < dateB) {
              return 1; // 返回负数表示 a 应该排在 b 前面
            }
            if (dateA > dateB) {
              return -1; // 返回正数表示 b 应该排在 a 前面
            }
            return this.tableData.lastIndexOf(b) - this.tableData.lastIndexOf(a);
          })
        }
      })
    },
    filterNameMethod ({ option, row }) {
      return row.name.indexOf(option.data) > -1
    },
    filterCityMethod ({ option, row }) {
      return row.city === option.value
    },
    filterAgeMethod ({ option, row }) {
      if (this.startAge === '') {
        this.startAge = 0
      }
      return row.age >= Number(this.startAge) && row.age <= Number(option.data)
    },
    filterAgeRecoverMethod ({ option }) {
      // 如果是自定义筛选模板，当为点击确认时，该选项将被恢复为默认值
      option.data = ''
      this.startAge = ''
    },
    filterNameRecoverMethod ({ option }) {
      option.data = ''
    }
  }
}
</script>

<style>
@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0)
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.apply-shake>.vxe-modal--box {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.icon--kehuxinxi {
  font-size: 18px;
}

.icon-xingming {
  font-size: 13px;
}

.icon-tishi {
  font-size: 15px;
}

.clientMain {
  width: 80%;
  border-radius: 8px;
  background: #fff;
  height: 500px;
  margin: 120px auto;
  background: rgb(239, 239, 239);
}

.vxe-table .vxe-sort--desc-btn {
  bottom: -0.2em;
}

.icon-tishi {
  font-size: 13px;
}

.vxe-icon--squar {
  display: none;
}

.vxe-icon--close {
  transform: rotate(45deg);
}

/* .clientManagerModel .vxe-modal--box{
  top: 255px!important;
}

.clientManagerQuestionnaire .vxe-modal--box{
  top: 225px!important;
} */
.clientManagerHeader,
.clientManagerModel .vxe-modal--header,
.clientManagerQuestionnaire .vxe-modal--header {
  background: #c90a5b;
  color: #fff;
}

.clientManagerQuestionnaire .vxe-modal--body,
.clientManagerQuestionnaire .vxe-input--inner {
  background: #faf6e6;
}

.clientManagerQuestionnaire .vxe-form .vxe-form--item {
  padding: 3px;
}

.clientManagerQuestionnaire .vxe-form--item-title .vxe-form--item-title-label {
  font-weight: bold;
}

.mytable-scrollbar .vxe-sort--asc-btn,
.mytable-scrollbar .vxe-sort--desc-btn,
.vxe-cell--filter .vxe-filter--btn,
.vxe-modal--wrapper .vxe-modal--close-btn:hover {
  color: #fff;
}

.mytable-scrollbar .vxe-sort--asc-btn:hover,
.mytable-scrollbar .vxe-sort--desc-btn:hover,
.mytable-scrollbar .vxe-sort--asc-btn.sort--active,
.mytable-scrollbar .vxe-sort--desc-btn.sort--active,
.vxe-cell--filter .vxe-filter--btn:hover,
.filter--active .vxe-cell--filter .vxe-filter--btn {
  color: orange;
}

/* .clientManagerRow {
  cursor: pointer;
} */

.vxe-select.is--active:not(.is--filter)>.vxe-input .vxe-input--inner {
  border: 1px solid #c90a5b;
}

.icon-V, .icon-shanchu{
  font-size: 18px;
}

.icon-V{
  display: inline-block;
  margin-top: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/ClientManage.vue